// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".breadcrumb-container[data-v-f50c2742]{padding-top:2rem;padding-bottom:.5rem;padding-left:1rem}.is-previous[data-v-f50c2742]{color:#253746}.is-active[data-v-f50c2742]{color:#939393;pointer-events:none}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
